import { render, staticRenderFns } from "./Cotacoes.vue?vue&type=template&id=549cd260&scoped=true"
import script from "./Cotacoes.vue?vue&type=script&setup=true&lang=js"
export * from "./Cotacoes.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Cotacoes.vue?vue&type=style&index=0&id=549cd260&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "549cd260",
  null
  
)

export default component.exports